function welcomeInit() {
  let welcome = document.querySelector('.welcome');
  let welcomeAbout = document.querySelector('.welcome__about');

  welcomeAbout.addEventListener('mouseover', () => {
    if (!welcome.classList.contains('about-active')) welcome.classList.add('about-hover')
  })

  welcomeAbout.addEventListener('mouseout', () => {
    if (!welcome.classList.contains('about-active')) welcome.classList.remove('about-hover')
  })

  document.addEventListener('click', (e) => {
    if (welcome.classList.contains('about-active')) {
      welcome.classList.remove('about-active')
    } else {
      if (e.target.closest('.welcome__about')) {
        welcome.classList.add('about-active')
        welcome.classList.remove('about-hover')
      }
    }
  })

  // welcomeAbout.addEventListener('click', () => {
  //   if (!welcome.classList.contains('about-active')) {
  //     welcome.classList.add('about-active')
  //     welcome.classList.remove('about-hover')
  //   }
  // })

  if (document.documentElement.clientWidth > 1023) {
    let wrapper = document.querySelector('.wrapper');
    let scrollWrapper = document.querySelector('.scroll-wrapper');
    let welcomeDescriptionItems = document.querySelectorAll('.welcome__description-item');
  
    welcomeDescriptionItems.forEach((item, i) => {
      item.animate(
        {
          opacity: [`0`, `1`],
          transform: ['translateX(100vw)', 'translateX(0)']
        },
        { duration: 10000, // Totally arbitrary!
          fill: 'both',
          timeline: new ScrollTimeline({
            source: wrapper,
            scrollSource: wrapper,
            orientation: 'horizontal',
            scrollOffsets: [
              CSS.px(scrollWrapper.clientWidth * 0.1 * i),
              CSS.px(scrollWrapper.clientWidth * 0.1 * (i + 1)),
            ],
          })
        }
      );
    })
  }


}

export { welcomeInit }